export enum SystemMessages {
  MESSAGE_001 = 'Operação realizada com sucesso.',
  MESSAGE_002 = 'Campo obrigatório não preenchido.',
  MESSAGE_003 = 'Informar um número válido.',
  MESSAGE_004 = 'Deseja Cancelar a operação?',
  MESSAGE_005 = 'Informar um E-mail válido.',
  MESSAGE_006 = 'Informar um Número de telefone válido.',
  MESSAGE_007 = 'Informar um Número de celular válido.',
  MESSAGE_008 = 'Informar uma Data válida.',
  MESSAGE_009 = 'Deseja realmente finalizar a oitiva informal?',
  MESSAGE_010 = 'O CRAAI é de preenchimento obrigatório.',
  MESSAGE_011 = 'A promotoria é de preenchimento obrigatório.',
  MESSAGE_012 = 'É obrigatório informar o AAAPAI.',
  MESSAGE_013 = 'É obrigatório informar o AIAI.',
  MESSAGE_014 = 'Os seguintes campos ficaram em branco, gostaria de prosseguir mesmo assim?',
  MESSAGE_015 = 'Formato de cep inválido.',
  MESSAGE_016 = 'Por favor, insira um endereço de email válido.',
  MESSAGE_017 = 'Os dados preenchidos até o momento foram salvos.',
  MESSAGE_018 = 'Oitiva informal finalizada com sucesso.',
  MESSAGE_019 = 'Atenção! A Promotoria foi alterada. Deseja continuar?',
  MESSAGE_020 = 'Pelo menos um campo deve ser informado para efetuar a pesquisa.',
  MESSAGE_021 = 'Download efetuado com sucesso.',
  MESSAGE_022 = 'Erro ao efetuar download. Tente novamente.',
  MESSAGE_023 = 'Deseja realmente excluir a oitiva informal?',
  MESSAGE_024 = 'Exclusão efetuada com sucesso.',
  MESSAGE_025 = 'É obrigatório informar o telefone por completo.',
  MESSAGE_026 = 'Deseja realmente reativar a oitiva excluída?',
  MESSAGE_027 = 'Oitiva informal reativada com sucesso.',
  MESSAGE_028 = 'Tamanho do arquivo excedido.',
  MESSAGE_029 = 'Exclusão efetuada com sucesso.',
  MESSAGE_030 = 'Formato inválido.',
  MESSAGE_031 = 'Dados salvos com sucesso.',
  MESSAGE_032 = 'Número do Processo (VIJ ou VEMSE) deve ser informado.',
  MESSAGE_DATE_IS_GREATER = 'Data de entrega do relatório menor que a data de início do cumprimento.',
  MESSAGE_MIN_SIZE_3 = 'O texto deve possuir o mínimo de 3 caracteres.',
  MESSAGE_MAX_SIZE_60 = 'O texto deve possuir o máximo de 60 caracteres.',
  MESSAGE_MAX_SIZE_50 = 'O texto deve possuir o máximo de 50 caracteres.',
  MESSAGE_FILE_OR_SIZE_FORMAT = 'Formato ou tamanho não permitido.',
}
